import React, { useEffect, useState } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import Select from 'react-select'
import { Modal, Row, Col } from 'react-bootstrap'
import { useLazyQuery, useMutation } from '@apollo/client'
import closeIcon from '../../../_metronic/images/closeSymbol.svg'
import {
  GET_SALESCHANNEL_PRODUCTS,
  GET_PRODUCT_FOR_AGENT,
  UPDATE_AGENT,
  GET_AGENT_LEADER_INFO_FOR_EDIT_AGENT,
} from '../../../utils/GraphQLAPI'
import { alert } from '../../../utils/helper'
import { GLOBAL_CONSTANTS } from '../../../utils/GlobalConstants'
import Dropdown from '../../sharedComponent/Dropdown/Dropdown'

const fetchPolicy = 'network-only'
const enrollSchema = Yup.object().shape({
  agentFirstName: Yup.string()
    .required('First Name is required')
    .matches(/^[0-9a-zA-Z \b]+$/, 'Special characters are not allowed')
    .matches(/^[^-\s][a-zA-Z0-9_\s-]+$/, 'Space not allowed')
    .min(3, "First Name shouldn't be less than 3 characters")
    .max(40, "First Name shouldn't exceed 40 characters"),
  agentLastName: Yup.string()
    .required('Last Name is required')
    .matches(/^[0-9a-zA-Z \b]+$/, 'Special characters are not allowed')
    .matches(/^[^-\s][a-zA-Z0-9_\s-]+$/, 'Space not allowed')
    .min(3, "Last Name shouldn't be less than 3 characters")
    .max(40, "Last Name shouldn't exceed 40 characters"),
  agentPassword: Yup.string().test(
    'password-validation',
    'Invalid password',
    function (value) {
      if (!value || value.trim() === '') {
        return this.createError({ message: 'Password is required' })
      }
      if (!value || value === '********') return true
      if (value.length < 8) return this.createError({ message: 'Minimum 8 characters required' })
      if (!/[a-z]/.test(value)) return this.createError({ message: 'At least one lowercase required' })
      if (!/[A-Z]/.test(value)) return this.createError({ message: 'At least one uppercase required' })
      if (!/\d/.test(value)) return this.createError({ message: 'At least one number required' })
      if (!/[^A-Za-z0-9]/.test(value)) return this.createError({ message: 'At least one symbol required' })
      return true
    }
  ),
})

export default function EditAgent({
  modalConfig,
  setShowEditModal,
  getSalesChannelAgents,
  agentLeaderList,
}: any) {
  const [options, setOptions] = useState<any>([])
  const [defaultValue, setDefaultValue] = useState<any>([])
  const [removedId, setRemovedId] = useState<any>([])
  const [isReady, setIsReady] = useState(false)

  const [getAgentLeaderCode] = useLazyQuery(GET_AGENT_LEADER_INFO_FOR_EDIT_AGENT, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    onCompleted: (data) =>
      formik.setFieldValue(
        'agentLeaderName',
        agentLeaderList.filter(
          (leader: any) => leader.leaderCode === data.getAgentLeaderInfoForAgent.leaderCode
        )[0].leaderName
      ),
  })
  const [getSaleschannelProducts] = useLazyQuery(GET_SALESCHANNEL_PRODUCTS, {
    fetchPolicy,
    onCompleted: (data) => {
      setOptions(
        data.getSalesChannelProducts.map((product: any) => ({
          value: product.id,
          label: product.name,
        }))
      )
    },
  })
  const [getProductsForAgents, { data: agentsProductsFromAPI }] = useLazyQuery(
    GET_PRODUCT_FOR_AGENT,
    {
      fetchPolicy,
      variables: { agentId: modalConfig.id },
      onCompleted: (data) => {
        setDefaultValue(
          data.getProductsForAgents.map((product: any) => ({
            value: product.prod_id,
            label: product.prod_name,
          }))
        )
      },
    }
  )
  const [updateAgent] = useMutation(UPDATE_AGENT, {
    fetchPolicy,
    onCompleted: () => {
      alert('Agent updated successfully', 'success')
      getSalesChannelAgents()
      handleClose()
    },
    onError: (e) => alert(e.message, 'error'),
  })
  useEffect(() => {
    if (modalConfig.show) {
      setIsReady(false) // reset on open

        ; (async () => {
          await getSaleschannelProducts()
          await getProductsForAgents()
          await formik.setValues({
            agentFirstName: modalConfig.agentFirstName,
            agentLastName: modalConfig.agentLastName,
            agentEmail: modalConfig.agentEmail,
            agentRepId: modalConfig.agentRepId,
            agentLeaderName: '',
            agentPassword: modalConfig.AgentUserName ? '********' : '-',
            agentUserName: modalConfig.AgentUserName,
          })
          getAgentLeaderCode({
            variables: {
              memberId: modalConfig.id,
            },
          })
          setIsReady(true)
        })()
    }
  }, [modalConfig])// eslint-disable-line react-hooks/exhaustive-deps
  const formik = useFormik({
    initialValues: {
      agentFirstName: '',
      agentLastName: '',
      agentEmail: '',
      agentLeaderName: '',
      agentRepId: '',
      agentPassword: '',
      agentUserName: '',

    },
    validationSchema: enrollSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      //addedproducts okay
      updateAgent({
        variables: {
          updateAgentInputs: {
            addProductIds: defaultValue
              .map((product: any) => product.value)
              .filter(
                (resultedProdId: any) =>
                  !agentsProductsFromAPI.getProductsForAgents
                    .map((product: any) => product.prod_id)
                    .includes(resultedProdId)
              ),
            removingIds: removedId,
            memberId: modalConfig.id,
            agentFirstName: values.agentFirstName,
            agentLastName: values.agentLastName,
            agentRepId: values.agentRepId,
            ...(values.agentPassword !== '********' && {
              password: values.agentPassword,
            }),
            leaderCode: Boolean(values.agentLeaderName)

              ? agentLeaderList.filter(
                (leader: any) => leader.leaderName === values.agentLeaderName
              )[0].leaderCode
              : null,

          },
        },
      })
    },
  })
  const handleClose = () => {
    setShowEditModal({
      show: false,
      id: '',
      agentFirstName: '',
      agentLastName: '',
      agentEmail: '',
      agentStatus: '',
      agentRepId: '',
      agentPassword: '',
      agentUserName: '',
      agentLeaderName: '',
    })
    setOptions([])
    setDefaultValue([])
    setRemovedId([])
  }
  const handleChange = (value: any) => {
    //check for removed or add
    if (value.length < defaultValue.length) {
      const removeId = defaultValue.filter(
        (product: any) => !value.map((prod: any) => prod.value).includes(product.value)
      )[0].value
      //if removed, check the id of removed data is in API data, if yes add that Id in removed id array of api input
      if (
        agentsProductsFromAPI.getProductsForAgents
          .map((prod: any) => prod.prod_id)
          .includes(removeId)
      ) {
        setRemovedId((prev: any) => [...prev, removeId])
      }
    } else {
      const addedId = value.filter(
        (product: any) => !defaultValue.map((prod: any) => prod.value).includes(product.value)
      )[0].value
      //if user deletes and add the ID which is existing in apiData we dont have to send it in removedId array of update API call
      if (
        agentsProductsFromAPI.getProductsForAgents
          .map((prod: any) => prod.prod_id)
          .includes(addedId)
      ) {
        //added product exisiting in removed ID
        setRemovedId(removedId.filter((id: any) => id !== addedId))
      }
    }
    setDefaultValue(value)
  }
  return (
    <Modal
      id='kt-modal_Edit_app'
      tabIndex={-1}
      aria-hidden='true'
      show={modalConfig.show}
      dialogClassName='modal-dialog modal-dialog modal-dialog-centered modal-fullscreen'
      onHide={() => handleClose()}
    >
      <div className='modal-content d-flex flex-column h-100'>
        <div className='modal-header'>
          <h5 className='modal-title text-gray-800 fs-3 fw-bolder'>
            {modalConfig.agentFirstName} {modalConfig.agentLastName}
          </h5>
          <div className='d-flex align-items-center'>
            <div className='d-flex  align-items-center'>
              <h6 className='text-gray-600 fs-6 fw-semibold'>Status : </h6>
              <h6>
                <span
                  className={`badge ${modalConfig.agentStatus === 'pending'
                    ? 'badge-light-warning'
                    : 'badge-light-success'
                    } p-2 ms-2 text-capitalize`}
                >
                  {modalConfig.agentStatus}
                </span>
              </h6>
            </div>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={(e) => handleClose()}
            >
              <img className='svg-icon-1' src={closeIcon} alt='close' />
            </div>
          </div>
        </div>
        <div className='modal-body overflow-auto flex-grow-1'>
          <div className='modal-body overflow-auto flex-grow-1'>
            {!isReady ? (
              <div className='text-center py-4 text-muted'>Loading...</div>
            ) : (
              <>
                <Row className='mb-5 d-flex align-items-end no-gutters noPadding'>
                  <Col>
                    <div className='mb-9'>
                      <label className='form-label'>
                        First Name <span className='h5 text-danger'>*</span>
                      </label>
                      <input
                        type='text'
                        className='form-control form-control-solid'
                        placeholder='Enter First Name'
                        {...formik.getFieldProps('agentFirstName')}
                      />
                      {formik.touched.agentFirstName && formik.errors.agentFirstName && (
                        <div className='fv-plugins-message-container'>
                          <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                            {formik.errors.agentFirstName}
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col>
                    <div className='mb-9'>
                      <label className='form-label'>
                        Last Name <span className='h5 text-danger'>*</span>
                      </label>
                      <input
                        type='text'
                        className='form-control form-control-solid'
                        placeholder='Enter Last Name'
                        {...formik.getFieldProps('agentLastName')}
                      />
                      {formik.touched.agentLastName && formik.errors.agentLastName && (
                        <div className='fv-plugins-message-container'>
                          <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                            {formik.errors.agentLastName}
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>

                <Row className='mb-5 d-flex align-items-end no-gutters noPadding'>
                  {formik.values.agentUserName === '-' && (
                    <Col>
                      <div className='mb-9'>
                        <label className='form-label'>
                          Email Id <span className='h5 text-danger'>*</span>
                        </label>
                        <input
                          type='email'
                          className='form-control form-control-solid'
                          placeholder='Enter Email'
                          readOnly={true}
                          {...formik.getFieldProps('agentEmail')}
                        />
                        {formik.touched.agentEmail && formik.errors.agentEmail && (
                          <div className='fv-plugins-message-container'>
                            <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                              {formik.errors.agentEmail}
                            </div>
                          </div>
                        )}
                      </div>
                    </Col>
                  )}

                  {formik.values.agentUserName === '-' && <Col>
                    <div className='mb-9'>
                      <label className='form-label'>Rep Id</label>
                      <input
                        type='text'
                        className='form-control form-control-solid'
                        placeholder='Enter RepId'
                        {...formik.getFieldProps('agentRepId')}
                      />
                      {formik.touched.agentRepId && formik.errors.agentRepId && (
                        <div className='fv-plugins-message-container'>
                          <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                            {formik.errors.agentRepId}
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>}
                  {formik.values.agentUserName !== '-' && (
                    <Col>
                      <div className='mb-9'>
                        <label className='form-label'>
                          User Name <span className='h5 text-danger'></span>
                        </label>
                        <input
                          type='text'
                          className='form-control form-control-solid'
                          placeholder='Enter User Name'
                          readOnly={true}
                          {...formik.getFieldProps('agentUserName')}
                        />
                        {formik.touched.agentUserName && formik.errors.agentUserName && (
                          <div className='fv-plugins-message-container'>
                            <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                              {formik.errors.agentUserName}
                            </div>
                          </div>
                        )}
                      </div>
                    </Col>
                  )}

                  {formik.values.agentUserName !== '-' && (
                    <Col>
                      <div className='mb-9'>
                        <label className='form-label'>
                          Login Password
                          <i
                            className='bi bi-info-circle ms-2 text-primary cursor-pointer'
                            onClick={() => alert(`${"To change your password, remove all placeholder values and follow this condition: Password must contain at least 8 characters, including one uppercase letter, one lowercase letter, one number, and one symbol (e.g., TpvSolutions@123)."}`, 'info')}
                          />

                        </label>
                        <input
                          type='text'
                          className='form-control form-control-solid'
                          placeholder='Enter Password'
                          {...formik.getFieldProps('agentPassword')}
                          readOnly={!!modalConfig.AgentUserName && modalConfig.AgentUserName === '-'}
                        />
                        {formik.touched.agentPassword && formik.errors.agentPassword && (
                          <div className='fv-plugins-message-container'>
                            <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                              {formik.errors.agentPassword}
                            </div>
                          </div>
                        )}
                      </div>
                    </Col>
                  )}
                </Row>

                {formik.values.agentUserName !== '-' && <Row className='mb-5 d-flex align-items-end no-gutters noPadding'>
                  <Col>
                    <div className='mb-9'>
                      <label className='form-label'>Rep Id</label>
                      <input
                        type='text'
                        className='form-control form-control-solid'
                        placeholder='Enter RepId'
                        {...formik.getFieldProps('agentRepId')}
                      />
                      {formik.touched.agentRepId && formik.errors.agentRepId && (
                        <div className='fv-plugins-message-container'>
                          <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                            {formik.errors.agentRepId}
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>}

                <div className='mb-7'>
                  <label className='form-label'>Assigned Products</label>
                  <Select
                    isMulti
                    value={defaultValue}
                    options={options}
                    isClearable={false}
                    onChange={(value: any) => handleChange(value)}
                  />
                </div>
                <label className='form-label'>Agent Leader</label>
                <Dropdown
                  fieldName={`agentLeaderName`}
                  optionList={agentLeaderList?.map((leader: any) => ({
                    id: leader.leaderName,
                    value: leader.leaderName,
                  }))}
                  formik={formik}
                  selectedVal={formik.values.agentLeaderName}
                  handleSelectedItem={(e: any, fieldName: any) =>
                    formik.setFieldValue(`agentLeaderName`, e.value)
                  }
                />
              </>
            )}
          </div>
        </div>
        <div className='modal-footer justify-content-end'>
          <button
            type='button'
            className='btn btn-light'
            data-bs-dismiss='modal'
            onClick={(e) => handleClose()}
          >
            Discard
          </button>
          <button type='submit' className='btn btn-primary' onClick={(e) => formik.submitForm()}>
            Update
          </button>
        </div>
      </div>
    </Modal>
  )
}
